import qs from 'qs';
import * as Api from "./../api";
import { axiosConfig, getContentTypeLogin, getContentTypeDefault, getContentTypeNonBearer } from "./../utils/headers"
import { setAuthToken, storage } from "./../utils/authToken"

const userId = storage.getUserId();
const userType = storage.getUserType();


class StoreService {

    async userLogin(payload) {
        let OAUTH_KEY = {
        }
        let { email, password, mobile } = payload
        let response = await axiosConfig.post(`${Api.API_LOGIN_INFORMATION}`, qs.stringify({ username: btoa(email), token: btoa(password), mobile: mobile }), {
            headers: getContentTypeLogin(),
            auth: OAUTH_KEY
        })
        return response
    }

    async getStoreList(city, type, page = 0) {
        return await axiosConfig.get(`${Api.API_GET_STORE_LIST}/?city=${city}&&type=${type}&&page=${page}`, {
            headers: getContentTypeDefault(),
        });
    }

    async getAllStoreList(page = 0) {
        return await axiosConfig.get(`${Api.API_ALL_GET_STORE_LIST}/?page=${page}`, {
            headers: getContentTypeDefault(),
        });
    }

    async getCityList(type = 'super') {
        const API_PATH = type === 'store' ? Api.API_GET_CITY_LIST : Api.API_GET_SUPER_CITY_LIST
        return await axiosConfig.get(`${API_PATH}`, {
            headers: getContentTypeDefault(),
        });
    }

    async getStoreListByCity(city, type = 'super') {
        const API_PATH = type === 'store' ? Api.API_GET_STORE_CITY_LIST : Api.API_GET_SUPER_STORE_CITY_LIST
        return await axiosConfig.get(`${API_PATH}/?city=${city}`, {
            headers: getContentTypeDefault(),
        });
    }

    async geStateList(type = 'super') {
        const API_PATH = type === 'store' ? Api.API_GET_STATE_LIST : Api.API_GET_SUPER_STATE_LIST
        return await axiosConfig.get(`${API_PATH}`, {
            headers: getContentTypeDefault(),
        });
    }


    async addStoreDetails(data) {

        let response = await axiosConfig.post(`${Api.API_POST_ADD_STORE_DATA}`, qs.stringify(data), {
            headers: getContentTypeDefault(),
        })

        return response
    }

    async updateStoreDetails(data) {
        let response = await axiosConfig.put(`${Api.API_POST_ADD_STORE_DATA}`, qs.stringify(data), {
            headers: getContentTypeDefault(),
        })

        return response
    }

    async deleteStoreById(id) {
        return await axiosConfig.delete(`${Api.API_DELETE_STORE_BY_ID}/?id=${id}`, {
            headers: getContentTypeDefault(),
        });
    }

    async getStoreById(id) {
        return await axiosConfig.get(`${Api.API_GET_STORE_BY_ID}/?id=${id}`, {
            headers: getContentTypeDefault(),
        });
    }

    async getGeoReverseInformation(geoLocation) {
        const { latitude, longitude } = geoLocation
        return await axiosConfig.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude?.toFixed(2)},${longitude?.toFixed(2)}&result_type=street_address&key=''&radius=10`);
    }

    getCityByState(administrative_area) {
        return axiosConfig.get(`${Api.API_GET_CITY_LIST_BY_STATE}/?administrative_area=${administrative_area.trim()}`, {
            headers: getContentTypeDefault(),
        });
    }

    async logout() {
        const data = {}
        data._id = userId;
        await axiosConfig.post(`${Api.API_LOGOUT_INFORMATION}`, qs.stringify(data), {
            headers: getContentTypeNonBearer(),
        })
        if (userType === "order") {
            localStorage.clear();
            window.location = "/storelocator/business/roma-login"
        } else {
            localStorage.clear();
            window.location = "/storelocator/business/login"
        }

    }

    async isUserLive() {
        const data = {}
        data._id = userId;
        return await axiosConfig.post(`${Api.API_IS_USER_LIVE}`, qs.stringify(data), {
            headers: getContentTypeDefault(),
        })
    }

    async updateBulkData(data) {
        let response = await axiosConfig.put(`${Api.API_UPDATE_BULK_STORE_DATA}`, data, {
            headers: getContentTypeDefault(),
        })

        return response
    }

    async updateBulkStoreMasterData(data) {
        let response = await axiosConfig.put(`${Api.API_UPDATE_BULK_STORE_MASTER_DATA}`, data, {
            headers: getContentTypeDefault(),
        })

        return response
    }

    async getUsersList(data) {
        return await axiosConfig.get(`${Api.API_GET_USERS_LIST}?${qs.stringify(data)}`, {
            headers: getContentTypeDefault(),
        });
    }

    async verifyEmail(email) {
        return await axiosConfig.get(`${Api.API_VERIFY_USER_EMAIL}?email=${email}`, {
            headers: getContentTypeDefault(),
        });
    }

    async getUserById(id) {
        return await axiosConfig.get(`${Api.API_GET_USER}/?id=${id}`, {
            headers: getContentTypeDefault(),
        });
    }

    async registerUser(data) {
        let response = await axiosConfig.post(`${Api.API_REGISTER_USER}`, qs.stringify(data), {
            headers: getContentTypeDefault(),
        })
        return response
    }

    async updateUser(data) {
        let response = await axiosConfig.put(`${Api.API_UPDATE_USER}`, qs.stringify(data), {
            headers: getContentTypeDefault(),
        })

        return response
    }

    async deleteUserId(id) {
        return await axiosConfig.delete(`${Api.API_DLETE_USER_BY_ID}/?id=${id}`, {
            headers: getContentTypeDefault(),
        });
    }

    async updatePassword(payload) {

        let { password, Id } = payload

        return await axiosConfig.put(`${Api.API_UPDATE_PASSWORD}`, qs.stringify({ password: window.btoa(password), Id: Id }), {
            headers: getContentTypeDefault()
        })

    }

    async getSalesReportData(type, page, params) {
        return await axiosConfig.post(`${Api.API_GET_SALES_REPORT_DATA}`, qs.stringify({ type: type, page: page, ...params }), {
            headers: getContentTypeDefault(),
        });
    }
    async getSalesReportDataJewelshub(type, page, params) {
        return await axiosConfig.post(`${Api.API_GET_SALES_REPORT_JEWELSHUB_DATA}`, qs.stringify({ type: type, page: page, ...params }), {
            headers: getContentTypeDefault(),
        });
    }

    async getSalesReportDataRj(type, page, params) {
        return await axiosConfig.post(`${Api.API_GET_SALES_REPORT_RJ_DATA}`, qs.stringify({ type: type, page: page, ...params }), {
            headers: getContentTypeDefault(),
        });
    }

    async getLiveSkuCountJewelsHub(type, params) {
        return await axiosConfig.post(`${Api.API_GET_JH_LIVE_SKU_COUNT}`, qs.stringify({ type: type, ...params }), {
            headers: getContentTypeDefault(),
        });
    }

    async getLiveDesignCountJewelsHub(type, params) {
        return await axiosConfig.post(`${Api.API_GET_JH_LIVE_DESIGN_COUNT}`, qs.stringify({ type: type, ...params }), {
            headers: getContentTypeDefault(),
        });
    }

    async sendOtp(params) {
        return await axiosConfig.post(`${Api.API_SEND_OTP}`, qs.stringify({ ...params }), {
            headers: getContentTypeDefault(),
        });
    }

    async verifyOtp(params) {
        const response = await axiosConfig.post(`${Api.API_VERIFY_OTP}`, qs.stringify({ ...params }), {
            headers: getContentTypeLogin(),
        });

        if (response.status === 200) {
            setAuthToken(response.data.data.token, '_business_panel_token')
            setAuthToken(response.data.data.user.type, '_type')
            setAuthToken(response.data.data.user._id, '_id')
            setAuthToken(response.data.data.user.is_password_reset, 'is_password_reset')
        }

        return response;
    }
}

const storeService = new StoreService();
export default storeService;